export enum FoodBoxStatus {
  ENROLLED = 'Enrolled',
  NOTENROLLED = 'NotEnrolled',
  AWAITINGDELIVERY = 'AwaitingDelivery',
  DELIVERED = 'Delivered',
}
